export const DEFAULT_AVAILABLE_THEME_MODES = ['light', 'dark'];
